import { Button, Card, Descriptions, Empty, Spin, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useDocumentRecord } from '@/entities/document/api/hooks';
import { StatusBadge } from '@/shared/ui/StatusBadge';
import { statusLabel } from '../constants';
import { docTypeTag } from '../utils';
import s from './DocumentRecordDetail.module.scss';

const { Paragraph, Link, Text } = Typography;

export function DocumentRecordDetail() {
  const { documentId } = useParams<{ documentId: string }>();
  const id = Number(documentId);
  const navigate = useNavigate();
  const { data, isLoading } = useDocumentRecord(id);

  if (!Number.isFinite(id) || id <= 0) {
    return <Empty description="Некорректный идентификатор документа" />;
  }

  return (
    <>
      <Button type="link" className={s.root__back} onClick={() => navigate('/documents')}>
        ← К реестру документов
      </Button>

      <Spin spinning={isLoading}>
        {!isLoading && data === null ? (
          <Empty description="Документ не найден" />
        ) : data ? (
          <>
            <Card className={s['root__header-card']} classNames={{ body: s['root__header-body'] }}>
              <div className={s['root__header-top']}>
                <div>
                  <Typography.Title level={5} className={s['root__header-title']}>
                    {data.title}
                  </Typography.Title>
                  <Text type="secondary" className={s['root__header-sub']}>
                    {data.details} · {data.scope}
                  </Text>
                </div>
                <StatusBadge status={data.status} label={statusLabel(data.status)} />
              </div>

              <Descriptions column={{ xs: 1, sm: 3 }} size="small" className={s['root__compact-desc']}>
                <Descriptions.Item label="Тип">{docTypeTag(data.docType)}</Descriptions.Item>
                <Descriptions.Item label="Актуализирован">{data.updatedDate}</Descriptions.Item>
                <Descriptions.Item label="Пересмотр">{data.nextReviewDate ?? '—'}</Descriptions.Item>
                <Descriptions.Item label="Владелец">{data.ownerUnit ?? '—'}</Descriptions.Item>
                <Descriptions.Item label="Реквизиты">{data.details}</Descriptions.Item>
                <Descriptions.Item label="Область">{data.scope}</Descriptions.Item>
              </Descriptions>

              {data.fileUri ? (
                <div className={s['root__file-row']}>
                  <Text type="secondary">Файл:</Text>
                  {data.fileUri.startsWith('https') ? (
                    <Link href={data.fileUri} target="_blank" rel="noreferrer">
                      {data.fileUri}
                    </Link>
                  ) : (
                    <Text code>{data.fileUri}</Text>
                  )}
                </div>
              ) : null}
            </Card>

            <Card
              className={s['root__excerpt-card']}
              title={<span className={s['root__excerpt-title']}>Описание</span>}
            >
              <Paragraph className={s.root__excerpt}>{data.excerpt ?? '—'}</Paragraph>
            </Card>
          </>
        ) : null}
      </Spin>
    </>
  );
}
